import React from 'react';
import { useIntl } from 'react-intl';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { GuestBillingInformationIcon } from '../../..//Common/Assets/SvgComponent/SiteAdminSvgIcon';
import messages from '../../../../locale/messages';

const GuestBillingInformation = ({
    cleaningPrice, convertCurrency, discount, total,
    discountType, serviceFee, taxPrice, taxValue,
    pricingData, refundToGuest, refundCurrency, serviceFeeType, serviceFeeValue,
    extraGuestFeeAmount, extraGuestCount, extraGuestFee, cautionDeposit
}) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.guestBillingInformation)} icon={<GuestBillingInformationIcon />}>
                <ViewTableBodyInformation
                    title={formatMessage(messages.rentalPrice)}
                    pricingData={pricingData}
                />
                {cleaningPrice > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.cleaningPrice)}
                    currencyData
                    amount={cleaningPrice}
                    convertCurrency={convertCurrency}
                />}
                {discount > 0 && <ViewTableBodyInformation
                    title={discountType}
                    currencyData
                    amount={discount}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {extraGuestFeeAmount > 0 && <ViewTableBodyInformation
                    title={`${extraGuestCount} x ${extraGuestFee} ${formatMessage(messages.extraGuestFee)}`}
                    currencyData
                    amount={extraGuestFeeAmount}
                    convertCurrency={convertCurrency}
                />}
                {serviceFee > 0 && <ViewTableBodyInformation
                    title={`${formatMessage(messages.serviceFee)} ${(serviceFeeType != 'fixed' && Number(serviceFeeValue) > 0) ? '(' + serviceFeeValue?.toFixed(2) + '%)' : ''} `}
                    currencyData
                    amount={serviceFee}
                    convertCurrency={convertCurrency}
                />}
                {taxPrice > 0 && <ViewTableBodyInformation
                    title={`${formatMessage(messages.tax)} ${taxValue > 0 && '(' + taxValue.toFixed(2) + '%)'} `}
                    currencyData
                    amount={taxPrice}
                    convertCurrency={convertCurrency}
                />}
                {cautionDeposit > 0 && <ViewTableBodyInformation
                    title="Caution Deposit"
                    currencyData
                    amount={cautionDeposit}
                    convertCurrency={convertCurrency}
                />}
                {total > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.total)}
                    currencyData
                    amount={total}
                    convertCurrency={convertCurrency}
                    isBold
                />}
                {refundToGuest > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.refundToGuest)}
                    currencyData
                    amount={refundToGuest}
                    convertCurrency={refundCurrency}
                    isBold
                />}
            </ViewTableInformation>
        </div>
    )
}

export default GuestBillingInformation;

